import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Services from "@/pages/Services";
import Readings from "@/pages/Readings";
import BookingPage from "@/pages/BookingPage";
import Membership from "@/pages/Membership";
import LandDefense from "@/pages/LandDefense";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminServices from "@/pages/admin/AdminServices";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminMessages from "@/pages/admin/AdminMessages";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Toaster position="top-center" theme="dark" richColors />
                        <Routes>
                            <Route element={<Layout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/shop" element={<Shop />} />
                                <Route path="/shop/:id" element={<ProductDetail />} />
                                <Route path="/services" element={<Services />} />
                                <Route path="/services/:id" element={<BookingPage kind="service" />} />
                                <Route path="/readings" element={<Readings />} />
                                <Route path="/readings/:id" element={<BookingPage kind="reading" />} />
                                <Route path="/membership" element={<Membership />} />
                                <Route path="/land-defense" element={<LandDefense />} />
                                <Route path="/journal" element={<Blog />} />
                                <Route path="/journal/:slug" element={<BlogPost />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/payment/success" element={<PaymentSuccess />} />
                                <Route path="/payment/cancel" element={<PaymentCancel />} />
                                <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                            </Route>
                            <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
                                <Route index element={<AdminDashboard />} />
                                <Route path="products" element={<AdminProducts />} />
                                <Route path="services" element={<AdminServices />} />
                                <Route path="orders" element={<AdminOrders />} />
                                <Route path="blog" element={<AdminBlog />} />
                                <Route path="members" element={<AdminMembers />} />
                                <Route path="newsletter" element={<AdminNewsletter />} />
                                <Route path="messages" element={<AdminMessages />} />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </CartProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
